<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <EncryptionApp></EncryptionApp>
</template>

<script>
import EncryptionApp from './components/EncryptionApp.vue';

export default {
  name: 'App',
  components: {
    EncryptionApp
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
